import { DELETE_CARD_APPLY_ERROR, DELETE_CARD_APPLY_START, DELETE_CARD_APPLY_SUCCESS } from '../../types';

export default function delete_card_apply(state, action) {
  switch (action.type) {
    case DELETE_CARD_APPLY_START:
      return { ...state };
    case DELETE_CARD_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_CARD_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}